import script from "./Targets.vue?vue&type=script&setup=true&lang=ts"
export * from "./Targets.vue?vue&type=script&setup=true&lang=ts"

export default script